
export enum AggregateNullValueType {
  LeaveAsNull = 1,
  SubstituteWithZero = 2
}

export const AggregateNullValueTypeToString:  {[key in AggregateNullValueType]: string}  = {
  [AggregateNullValueType.LeaveAsNull]: 'Leave As Null',
  [AggregateNullValueType.SubstituteWithZero]: 'Substitute With Zero'
};
